/**
 * お問い合わせフォーム 確認画面
 * 「確認する」ボタンで入力値を確認画面に表示し、「送信する」でCF7送信
 */

const contactFormConfirm = () => {
  const confirmBtn = document.querySelector('.js-contact-confirm');
  const backBtn = document.querySelector('.js-contact-back');
  const confirmArea = document.querySelector('.js-contact-confirm-area');

  if (!confirmBtn || !backBtn || !confirmArea) return;

  const form = confirmBtn.closest('form');
  if (!form) return;

  // -----------------------------------------------
  // 値取得ヘルパー
  // -----------------------------------------------
  const get = (fieldName) =>
    form.querySelector(`[name="${fieldName}"]`)?.value?.trim() ?? '';

  const getCheckedAll = (fieldName) =>
    [...form.querySelectorAll(`[name="${fieldName}"]:checked`)]
      .map((el) => el.value)
      .join('、');

  const set = (selector, text) => {
    const el = confirmArea.querySelector(selector);
    if (el) el.textContent = text;
  };

  const setHtml = (selector, html) => {
    const el = confirmArea.querySelector(selector);
    if (el) el.innerHTML = html;
  };

  // -----------------------------------------------
  // 確認画面へ値を反映
  // -----------------------------------------------
  const populateConfirm = () => {
    set('.js-c-name', get('your-name'));
    set('.js-c-company', get('your-company'));
    set('.js-c-email', get('your-email'));
    set('.js-c-tel', get('your-tel'));
    set('.js-c-type', getCheckedAll('your-type[]'));
    setHtml('.js-c-message', get('your-message').replace(/\n/g, '<br>'));
  };

  // -----------------------------------------------
  // バリデーション
  // -----------------------------------------------
  const validate = () => {
    let isValid = true;

    form.querySelectorAll('[aria-required="true"]').forEach((field) => {
      if (!field.value.trim()) isValid = false;
    });

    const acceptance = form.querySelector('[name="your-privacy"]');
    if (acceptance && !acceptance.checked) isValid = false;

    return isValid;
  };

  const showValidationErrors = () => {
    let firstInvalidWrap = null;

    const markError = (field, message) => {
      const wrap = field.closest('.wpcf7-form-control-wrap');
      if (!wrap) return;
      wrap.classList.add('is-submitted');
      if (!wrap.querySelector('.wpcf7-not-valid-tip')) {
        const tip = document.createElement('span');
        tip.className = 'wpcf7-not-valid-tip';
        tip.setAttribute('role', 'alert');
        tip.textContent = message;
        wrap.appendChild(tip);
      }
      if (!firstInvalidWrap) firstInvalidWrap = wrap;
    };

    const clearError = (field) => {
      const wrap = field.closest('.wpcf7-form-control-wrap');
      wrap?.classList.remove('is-submitted');
      wrap?.querySelector('.wpcf7-not-valid-tip')?.remove();
    };

    form.querySelectorAll('[aria-required="true"]').forEach((field) => {
      if (!field.value.trim()) {
        markError(field, '入力してください');
      } else {
        clearError(field);
      }
    });

    const acceptance = form.querySelector('[name="your-privacy"]');
    if (acceptance) {
      if (!acceptance.checked) {
        markError(acceptance, '同意してください');
      } else {
        clearError(acceptance);
      }
    }

    if (firstInvalidWrap) {
      const row =
        firstInvalidWrap.closest('.m-contact-form__row') ?? firstInvalidWrap;
      const headerHeight =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue(
            '--js-height__header',
          ),
        ) || 0;
      const scrollTop =
        window.scrollY + row.getBoundingClientRect().top - headerHeight - 24;
      window.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }
  };

  // -----------------------------------------------
  // 入力 → 確認
  // -----------------------------------------------
  confirmBtn.addEventListener('click', () => {
    if (!validate()) {
      showValidationErrors();
      return;
    }

    populateConfirm();

    form.querySelector('.m-contact-form')?.setAttribute('hidden', '');
    confirmBtn.setAttribute('hidden', '');
    confirmArea.removeAttribute('hidden');

    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  // -----------------------------------------------
  // 確認 → 入力へ戻る
  // -----------------------------------------------
  backBtn.addEventListener('click', () => {
    confirmArea.setAttribute('hidden', '');
    confirmBtn.removeAttribute('hidden');
    form.querySelector('.m-contact-form')?.removeAttribute('hidden');

    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
};

export { contactFormConfirm };
